import * as types from 'actions/actionTypes';
import env from 'utilities/env';
import { get } from 'lodash';

// @todo e2e hack remove once web ripped out of monolith
// and e2e can clear session storage pre running each test
const isSessionStorageDisabled = env('DISABLE_SESSION_STORAGE') === 'true';

const isUnavailable = get(window, 'sessionStorage', undefined) === undefined || isSessionStorageDisabled;

const isParsableJSON = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};


const getItem = (key) => {
  const item = window.sessionStorage.getItem(key);
  if (isParsableJSON(item)) {
    return JSON.parse(item);
  }
  return null;
};

const setItem = (key, value) => {
  const currentData = getItem(key) || {};
  const newData = JSON.stringify({ ...currentData, ...value });
  window.sessionStorage.setItem(key, newData);
};

const clearItem = (key) => {
  window.sessionStorage.removeItem(key);
};

// payloads passed to browser storage must be an object
export const browserStorage = () => (next) => (action) => {
  let result = next(action);
  const { type, payload, meta } = action;
  const fingerprint = get(meta, 'fingerprint');
  const otr = get(meta, 'otr', false); // otr is off the record and not saved to storage

  if (isUnavailable || otr) return result;

  switch (type) {
    case types.SET_BROWSER_STORAGE_ITEM:
      setItem(fingerprint, payload);
      break;
    case types.CLEAR_BROWSER_STORAGE_ITEM:
      clearItem(fingerprint);
      break;
    case types.GET_BROWSER_STORAGE_ITEMS: {
      const hydratedPayload = Object.keys(window.sessionStorage).reduce(
        (acc, key) => ({ ...acc, [key]: getItem(key) }),
        {}
      );

      const nextAction = { ...action, payload: hydratedPayload };
      result = next(nextAction);
      break;
    }
    default:
      break;
  }
  return result;
};
